import { useState } from "react";
import moment from "moment";
import { FormControl, FormHelperText, styled } from "@mui/material";
import TimeField from "./TimeField";

const ContainerStyled = styled("div")({
  display: "flex",
  alignItems: "center",
});

const TimeRangeField = ({
  startLabel,
  endLabel,
  startPlaceholder,
  endPlaceholder,
  startDefaultValue,
  endDefaultValue,
  seperator = "-",
  isDisabled,
  onChange,
  isError,
  helperText,
  format,
  fieldClassName,
  fieldStyle,
  locale = "en",
  isAmPm,
}) => {
  const [timeRange, setTimeRange] = useState({
    start: startDefaultValue || null,
    end: endDefaultValue || null,
  });

  const handleStartChange = (time) => {
    const shouldNotEraseEndTime =
      timeRange.end == null || moment(time).isBefore(timeRange.end);
    setTimeRange((prev) => ({
      ...prev,
      start: time,
      end: shouldNotEraseEndTime ? prev.end : null,
    }));

    if (time != null && timeRange.end != null && shouldNotEraseEndTime) {
      onChange?.({
        start: time,
        end: timeRange.end,
      });
    }
  };

  const handleEndChange = (time) => {
    setTimeRange((prev) => ({
      ...prev,
      end: time,
    }));

    if (time != null && timeRange.start != null) {
      onChange?.({
        start: timeRange.start,
        end: time,
      });
    }
  };

  return (
    <FormControl>
      <ContainerStyled>
        <TimeField
          label={startLabel}
          placeholder={startPlaceholder}
          value={timeRange.start}
          defaultValue={startDefaultValue}
          isDisabled={isDisabled}
          isError={isError}
          format={format}
          locale={locale}
          isAmPm={isAmPm}
          className={fieldClassName}
          style={fieldStyle}
          onChange={handleStartChange}
        />
        {seperator}
        <TimeField
          label={endLabel}
          placeholder={endPlaceholder}
          value={timeRange.end}
          defaultValue={endDefaultValue}
          isDisabled={isDisabled}
          isError={isError}
          format={format}
          locale={locale}
          isAmPm={isAmPm}
          className={fieldClassName}
          style={fieldStyle}
          minTime={timeRange.start}
          onChange={handleEndChange}
        />
      </ContainerStyled>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default TimeRangeField;
